import { memo } from 'react';

import type { ModelLead } from '@app/api/Leads/types';

import { useLeadResponseTime } from '../../../../model/hooks/useLeadResponseTime';

import type { FC } from 'react';

interface ResponseTimeCellProps {
  lead: ModelLead;
}

const ResponseTimeCellComponent: FC<ResponseTimeCellProps> = ({ lead }) => {
  const responseTime = useLeadResponseTime(lead);

  if (!responseTime) {
    return null;
  }

  return (
    <div className="LeadsRegistryTable__stacked-cell">
      <span
        className={`LeadsRegistryTable__response LeadsRegistryTable__response--${responseTime.status}`}
      >
        {responseTime.label}
      </span>
    </div>
  );
};

export const ResponseTimeCell = memo(ResponseTimeCellComponent);
